// Site home (same value as .env.production). Fallback for local dev, which has no committed
// .env: without it, CTAs like "Explorar outros eventos" would point to href="undefined".
const DEFAULT_SITE_URL = 'https://ingresse.com/';

export const Environment = {
  API_URL : import.meta.env.VITE_API_URL,
  NODE_ENV : import.meta.env.VITE_NODE_ENV,
  API_EVENT_URL : import.meta.env.VITE_API_EVENT_URL,
  API_TICKETS_URL : import.meta.env.VITE_API_TICKETS_URL,
  API_BACKSTAGE_URL : import.meta.env.VITE_API_BACKSTAGE_URL,
  API_KEY : import.meta.env.VITE_API_KEY,
  ENVIRONMENT : import.meta.env.VITE_DEFAULT_ENVIRONMENT,
  INGRESSE_URL : import.meta.env.VITE_INGRESSE_URL,
  SUPPORT_LINK : import.meta.env.VITE_SUPPORT_LINK,
  PREFIX_TOKEN : import.meta.env.VITE_PREFIX_TOKEN,
  WALLET_VERIFY_API : import.meta.env.VITE_WALLET_VERIFY_API,
  WHITELIST_VERIFY_API : import.meta.env.VITE_WHITELIST_VERIFY_API,
  API_GATEWAY_URL : import.meta.env.VITE_API_GATEWAY_URL,
  API_FASTPASS_OFFER_URL : import.meta.env.VITE_API_FASTPASS_OFFER_URL,
  SITE_URL : import.meta.env.VITE_SITE_URL || DEFAULT_SITE_URL,
  WALLET_URL : import.meta.env.VITE_WALLET_URL,
  SIFT_KEY : import.meta.env.VITE_SIFT_KEY,
  PUBLIC_POSTHOG_KEY : import.meta.env.VITE_PUBLIC_POSTHOG_KEY,
  PUBLIC_POSTHOG_HOST : import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
  API_META_CONVERSIONS_URL : import.meta.env.VITE_API_META_CONVERSIONS_URL
} as const;

type EnvironmentType = keyof typeof Environment;
type EnvironmentValuesTypes = typeof Environment[keyof typeof Environment];

export type { EnvironmentType, EnvironmentValuesTypes };
